<template>
    <basic-modal :title="modalTitle" :target-id="targetId" set-class="modal-lg">
        <template v-slot:modal_body>
            <create-tender
                ref="tenderForm"
                :is-edit="isEditMode"
                :tender="tender"
                @stored="handleStored"
            />
        </template>
        <template v-slot:first_button>
            <button
                @click="$refs.tenderForm.store()"
                :class="['btn', isEditMode ? 'btn-outline-info' : 'btn-outline-success']"
            >
                {{ isEditMode ? 'Save' : 'Create' }}
            </button>
        </template>
    </basic-modal>
</template>

<script>
import CreateTender from "./CreateTender.vue";
import BasicModal from "../Basic/BasicModal.vue";

export default {
    name: "TenderModal",
    components: { CreateTender, BasicModal },
    props: {
        mode: {
            type: String,
            required: true,
            validator: (value) => ["create", "edit"].includes(value),
        },
        tender: {
            type: Object,
            default: null,
        },
        targetId: {
            type: String,
            required: true,
        },
    },
    computed: {
        isEditMode() {
            return this.mode === "edit";
        },
        modalTitle() {
            return this.isEditMode ? "Edit Tender" : "Add Tender";
        },
    },
    methods: {
        handleStored() {
            this.$emit("stored");
            $(`#${this.targetId}`).modal("hide");
        },
    },
};
</script>
